import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AbsenceTypeEnum } from '@qaroni-app/absences/types/absence-type.enum';

@Component({
  selector: 'qaroni-absence-type-preview',
  templateUrl: './absence-type-preview.component.html',
  styleUrls: ['./absence-type-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AbsenceTypePreviewComponent {
  readonly type = input<AbsenceTypeEnum>(AbsenceTypeEnum.HOLIDAYS);

  get typeEnum(): typeof AbsenceTypeEnum {
    return AbsenceTypeEnum;
  }
}
